export const BUY_PAGE_FILTERS = ['price', 'priceTrade', 'location'];
